// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import Icon from 'app/common/components/Icon';
import { STATUS_ICONS } from 'app/history/utils/constants';
import 'app/history/components/TaskStatusIcon.scss';

const bem = bemify('task-status-icon');

type TaskStatusIconProps = {
  status?: string,
  kind?: string,
  className?: string,
  showPathIcon: boolean,
};

const TaskStatusIcon = ({
  status,
  kind,
  className,
  showPathIcon,
}: TaskStatusIconProps) => {
  const icon = status ? STATUS_ICONS[status] : '';

  return (
    <div className={bem(className, toModifiers(icon, kind))}>
      <Icon className={bem('__icon')} type={icon} />
      {showPathIcon && <Icon className={bem('__path-icon')} type="path" />}
    </div>
  );
};

TaskStatusIcon.defaultProps = {
  showPathIcon: false,
};

export default TaskStatusIcon;
